import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

import { cn } from "@/lib/utils";
import { Calendar as CalendarIcon } from "lucide-react";

import { motion } from "framer-motion";
import Lottie from 'lottie-react';
import Moment from 'moment';

import { useRecoilState } from 'recoil';
import { subAtom } from 'core/config/atoms';

import TopBar from 'core/widgets/ui/TopBar';

import animPage from 'assets/anim/anim-pageload.json';

import ComponentCardBooking from './components/card/ComponentCardBooking';
import ComponentCardHostelBooking from './components/card/ComponentCardHostelBooking';
import ComponentCardBookingSales from './components/card/ComponentCardBookingSales';
import ComponentCardAttendance from './components/card/ComponentCardAttendance';

import ComponentListBooking from './components/list/ComponentListBooking';
import ComponentListBookingPMode from './components/list/ComponentListBookingPMode';
import ComponentChartBooking from './components/chart/ComponentChartBooking';

import ComponentTableBooking from './components/table/ComponentTableBooking';
import ComponentTableHostelBooking from './components/table/ComponentTableHostelBooking';

export default function PanelBookReports(props) {

    const [sub] = useRecoilState(subAtom);

    const [date, setDate] = useState({
        from: Moment().subtract('day', 1).toDate(),
        to: Moment().toDate(),
    });

    const [loading, setLoading] = useState(true);

    const onDateChange = (event) => {
        setDate(event);
    }

    const loadData = () => {
        (async function () {
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <ScrollArea className="w-full h-full">
            {
                loading && <div className='flex items-center justify-center w-full h-full'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            <div className="grid grid-cols-12 grid-gap-2">
                <div className="col-span-12 mt-2">
                    <div className="intro-y flex items-center justify-between h-10 border-b pb-4">
                        <h2 className="text-2xl font-medium truncate ml-2">
                            <motion.i whileHover={{ scale: 1.2 }} className="las la-bars cursor-pointer" onClick={() => { props.onToggle(); }}></motion.i> Reports Overview
                        </h2>
                        <TopBar />
                    </div>
                    <div className="w-full h-full">
                        {
                            !loading && <>
                                <div className='flex items-center justify-between my-2'>
                                    <h1 className='text-xl font-medium truncate ml-2'>Overview Booking Report</h1>
                                    <div>
                                        <Popover>
                                            <PopoverTrigger asChild>
                                                <Button id="date" variant={"outline"}
                                                    className={cn("w-[300px] justify-start text-left font-normal", !date && "text-muted-foreground")}>
                                                    <CalendarIcon className="mr-2 h-4 w-4" />
                                                    {date?.from ? (
                                                        date.to ? (
                                                            <>
                                                                {Moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                {Moment(date.to).format('MMM DD, yyyy')}
                                                            </>
                                                        ) : (
                                                            Moment(date.from).format('MMM DD, yyyy')
                                                        )
                                                    ) : (
                                                        <span>Pick a date</span>
                                                    )}
                                                </Button>
                                            </PopoverTrigger>
                                            <PopoverContent className="w-auto p-0" align="start">
                                                <Calendar
                                                    initialFocus
                                                    mode="range"
                                                    defaultMonth={date?.from}
                                                    selected={date}
                                                    onSelect={onDateChange}
                                                    numberOfMonths={2}
                                                />
                                            </PopoverContent>
                                        </Popover>
                                    </div>
                                </div>
                                <div className="grid grid-cols-4 lg:grid-cols-10 mt-6 mb-5 gap-2 xl:gap-5 ml-2">
                                    <ComponentCardBooking range={date} />
                                    <ComponentCardBookingSales range={date} />
                                    {sub.apps.includes("APP00002") && <ComponentCardHostelBooking range={date} />}
                                    {sub.apps.includes("APP00002") && <ComponentCardAttendance range={date} />}
                                </div>
                                <div className='grid grid-cols-4 lg:grid-cols-12 mt-6 mb-5 gap-2 xl:gap-5 ml-2'>
                                    <ComponentListBooking range={date} hbook={sub.apps.includes("APP00002")} />
                                    <ComponentListBookingPMode range={date} />
                                    <ComponentChartBooking range={date} hbook={sub.apps.includes("APP00002")} />
                                </div>
                                <div className='grid grid-cols-4 lg:grid-cols-12 mt-6 mb-5 gap-2 xl:gap-5 ml-2'>
                                    {!sub.apps.includes("APP00002") && <ComponentTableBooking range={date} />}
                                    {sub.apps.includes("APP00002") && <ComponentTableHostelBooking range={date} />}
                                </div>
                                <div className='grid grid-cols-4 lg:grid-cols-12 mt-6 mb-5 gap-2 xl:gap-5 ml-2'></div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </ScrollArea>
    )
}
